export default "__VITE_ASSET__BRRrZIEj__"